import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { scrollBarNoHeight } from 'src/styles/styles';
import { flex } from 'src/styles/utils';

export const PlansWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 100px;
  ${MediaBP.MediaLg} {
    height: 80%;
    overflow-y: scroll;
    ${scrollBarNoHeight}
  }
`;

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  ${flex('column', 'space-around', 'flex-start')};
  gap: 8px;
  padding: 16px;
  color: ${colors.PrimaryWhiteColor};
  background: ${colors.black};
`;
export const premiumContainer = css`
  background: linear-gradient(
    146deg,
    #10151a 0.77%,
    #362f63 31.32%,
    #0c090e 63.75%
  );
`;
export const Header = styled.div`
  ${ZeeFontBold(18, 24)};
  ${MediaBP.MediaMd} {
    ${ZeeFontBold(24, 36)};
  }
`;
export const Description = styled.div`
  ${ZeeFontRegular(12, 16)};
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(18, 24)};
  }
`;
export const whitePill = css`
  background: ${colors.PrimaryWhiteColor};
  border-color: ${colors.PrimaryWhiteColor};
  color: ${colors.PrimaryBlackColor};
`;

export const goldPill = css`
  background: ${colors.YellowGold};
  border-color: ${colors.YellowGold};
`;
export const transparentPill = css`
  border-color: ${colors.PrimaryWhiteColor};
  color: ${colors.PrimaryWhiteColor};
`;
export const Pill = styled.button`
  flex: 1;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: white;
  font-weight: bold;
  font-size: 14px;
  border-radius: 999px;
  cursor: pointer;
  position: relative;
  text-align: center;
  min-width: 90px;
  position: relative;
  ${MediaBP.MediaLg} {
    min-width: 120px;
  }
`;

export const PillsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  background: #1c122b;
  border-radius: 30px;
  padding: 4px;
  position: relative;
  margin-top: 20px;
  overflow-y: auto;
  ${scrollBarNoHeight}
  ${MediaBP.MediaLg} {
    width: auto;
    overflow-y: visible;
    max-width: 100%;
  }
`;

export const FeaturesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 24px;
`;

export const PlanCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin-top: 16px;

  ${MediaBP.TabletPortraitMaxWidth} {
    flex-direction: column;
  }
`;

export const ViewOtherPlans = styled.button`
  background: transparent;
  border: 1px solid #888;
  border-radius: 4px;
  color: ${colors.PrimaryWhiteColor};
  font-size: 14px;
  font-weight: 600;
  padding: 10px 0;
  text-align: center;
  width: 100%;
  cursor: pointer;
  margin-top: 16px;
`;

export const IconStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FeaturesContainerTitle = styled.div`
  ${ZeeFontBold(16, 24)};
  padding-right: 20px;
  color: ${colors.PrimaryWhiteColor};
  ${MediaBP.MediaMd} {
    ${ZeeFontBold(24, 36)};
  }
`;

export const PromoBadgeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
`;
